import { BlButton } from "Shared/Buttons/BlButton";
import { BlDefaultButton } from "Shared/Buttons/BlDefaultButton";
import { BlConfirmDialog } from "Shared/Dialogs/BlConfirmDialog";
import { BlTooltip } from "Shared/BlTooltip";
import { PropsWithChildren, useState } from "react";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import CircularProgress from "@mui/material/CircularProgress";

type Props = {
	tooltip?: string | JSX.Element;
	tooltipPlacement?: "top" | "bottom" | "left" | "right" | "top-start" | "top-end" | "bottom-start" | "bottom-end" | "left-start" | "left-end" | "right-start" | "right-end";
	modalTitle: string | JSX.Element;
	modalContent: string | JSX.Element;
	modalMaxWidth?: string | undefined;
	onResult: (result: boolean) => void;
	confirmButtonText?: string;
	disabled?: boolean;
	isLoading?: boolean;
	variant?: "primary" | "secondary" | "default" | "error" | "warning";
	onClick?: () => boolean;
	iconButton?: boolean;
	icon?: JSX.Element;
};

export const BlConfirmButton: React.FunctionComponent<
	PropsWithChildren<Props>
> = (props) => {
	const {
		onResult,
		tooltip,
		tooltipPlacement,
		modalContent,
		modalTitle,
		modalMaxWidth,
		children,
		disabled,
		confirmButtonText,
		isLoading,
		onClick,
		iconButton,
		icon,
	} = props;
	const variant = props.variant ?? "default";

	const [isOpen, setIsOpen] = useState(false);

	const handleResult = (result: boolean) => {
		setIsOpen(false);
		onResult(result);
	};

	const handleClick = () => {
		let ok = true;
		if (onClick !== undefined) {
			ok = onClick();
		}
		if (ok) {
			setIsOpen(true);
		}
	};

	return (
		<>
			{iconButton ? (
				tooltip ? (
					<BlTooltip title={tooltip} placement={tooltipPlacement}>
						<IconButton
							onClick={handleClick}
							disabled={disabled}
							color={variant}
						>
							{isLoading ? <CircularProgress size={20} /> : icon}
						</IconButton>
					</BlTooltip>
				) : (
					<IconButton
						onClick={handleClick}
						disabled={disabled}
						color={variant}
					>
						{isLoading ? <CircularProgress size={20} /> : icon}
					</IconButton>
				)
			) : (
				<>
					{variant === "default" ? (
						<BlDefaultButton
							title={tooltip}
							disabled={disabled}
							isLoading={isLoading}
							onClick={handleClick}
						>
							{children}
						</BlDefaultButton>
					) : (
						<BlButton
							color={variant}
							disabled={disabled}
							isLoading={isLoading}
							onClick={handleClick}
						>
							{children}
						</BlButton>
					)}
				</>
			)}

			<BlConfirmDialog
				isOpen={isOpen}
				handleResult={handleResult}
				modalContent={modalContent}
				modalTitle={modalTitle}
				modalMaxWidth={modalMaxWidth}
				confirmButtonText={confirmButtonText}
			/>
		</>
	);
};
